//src/firebase/config.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDVUJoa2N3s9e_Nco2QH1C1cieSTCY-snw",
  authDomain: "student-id-maker.firebaseapp.com",
  projectId: "student-id-maker",
  storageBucket: "student-id-maker.firebasestorage.app",
  messagingSenderId: "503305793949",
  appId: "1:503305793949:web:f94ea1490160ac657a3f74",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, 'asia-south1');